import { Outlet, RouteObject } from "react-router-dom";
import Inspection from "./pages/inspection";
import InspectionsDetail from "./pages/fragments/inspection-details";




const routes: RouteObject = {
    path: "inspections",
    element: <Outlet />,
    children: [
        {
            index: true,
            element: <Inspection />
        },
        {
            path: "",
            element: <Inspection />,
            children: [
                {
                    path: ":id",
                    element: <InspectionsDetail />
                }
            ]
        },
    ]
}

export default routes